/** Turn ISO-3166 alpha-2 (YE, MR) or a stored name into a readable English country. */
const DISPLAY = typeof Intl !== "undefined" && "DisplayNames" in Intl
  ? new Intl.DisplayNames(["en"], { type: "region" })
  : null;

export function countryLabel(value: string | null | undefined): string {
  if (!value?.trim()) return "—";
  const raw = value.trim();
  if (/^[A-Za-z]{2}$/.test(raw)) {
    const code = raw.toUpperCase();
    try {
      const name = DISPLAY?.of(code);
      if (name && name !== code) return name;
    } catch {
      /* invalid region code */
    }
    return code;
  }
  return raw;
}

export function countryMatches(value: string | null | undefined, needle: string): boolean {
  if (!value) return false;
  const n = needle.toLowerCase();
  return value.toLowerCase().includes(n) || countryLabel(value).toLowerCase().includes(n);
}
